import http from "@/utils/request";

/**
 * service-supply 接口封装（与 ui-selection 共用同一套后端，接口不变）
 * 后端 context-path 为 /supplyapi
 */

const PREFIX = "/supplyapi";

/* ------------------------------- 账号 ------------------------------- */

// 经销商登录
export function login(data) {
  return http.post(`${PREFIX}/selectionMallHome/login`, {
    owner: "CHANNEL_MANAGER",
    ...data,
  });
}

// 退出登录
export function logout() {
  return http.post(`${PREFIX}/user/logout`);
}

// 当前登录分销商信息
export function queryLoginInfo() {
  return http.post(`${PREFIX}/selectionMallHome/queryLoginInfo`);
}

// 首页轮播图（免登录）
export function queryCarousel() {
  return http.post(`${PREFIX}/selectionMallHome/queryCarousel`, {
    position: "HOME_PAGE",
    tenantSource: "JU_YANG",
  });
}

// 首页分类树（免登录）
export function queryHomeCategory() {
  return http.post(`${PREFIX}/selectionMallHome/queryCategory`, {
    pager: { pageSize: 9999, curPageNum: 1 },
  });
}

// 推荐给经销商的商品（免登录可看，登录后返回经销商价）
export function queryNewProduct(params) {
  return http.post(`${PREFIX}/selectionMallHome/queryNewProduct`, params);
}

/* ------------------------------- 商品 ------------------------------- */

// 商品类目树
export function queryCategoryList() {
  return http.post(`${PREFIX}/selectionMallProduct/queryCategoryList`, {});
}

// 经销商选品商品分页（需登录）
export function queryProduct(params) {
  return http.post(`${PREFIX}/selectionMallProduct/queryProduct`, params);
}

// 经销商商品详情（需登录）
export function queryProductDetail(id) {
  return http.post(`${PREFIX}/selectionMallProduct/queryProductDetail`, {
    id,
  });
}

// 企业集采商品分页（免登录）
export function queryEnterpriseProduct(params) {
  return http.post(
    `${PREFIX}/selectionMallProduct/queryEnterpriseProduct`,
    params
  );
}

// 企业集采商品详情（免登录）
export function queryEnterpriseProductDetail(id) {
  return http.post(
    `${PREFIX}/selectionMallProduct/queryEnterpriseProductDetail`,
    { id }
  );
}

/* --------------------------- 经销商加入商城 --------------------------- */

// 将商品加入商城（加入货架并推送）
export function addMerchant(ids) {
  return http.post(`${PREFIX}/selectionMallProduct/addMerchant`, { ids });
}

// 已加入商城（货架）商品分页
export function queryShelveProduct(params) {
  return http.post(`${PREFIX}/selectionMallOrder/queryShelveProduct`, params);
}

// 已加入商城数据汇总
export function queryShelveSummary(params) {
  return http.post(`${PREFIX}/selectionMallOrder/queryShelveSummary`, params);
}

// 移除已加入商城的商品
export function deleteShelveProduct(ids) {
  return http.post(`${PREFIX}/selectionMallOrder/deleteShelveProductAll`, {
    ids,
  });
}

// 推送未推送的货架商品
export function pushShelveProduct(ids) {
  return http.post(`${PREFIX}/selectionMallOrder/pushShelveProduct`, {
    ids,
  });
}

/* ----------------------------- 企业集采 ----------------------------- */

// 省市区数据
export function queryRegionTree() {
  return http.post(`${PREFIX}/location/queryProvinceCityDistrict`, {
    level: 3,
  });
}

// 企业集采下单（免登录）
export function placeEnterpriseOrder(payload) {
  return http.post(`${PREFIX}/enterprisePurchase/place`, payload);
}

// 凭订单号 + 收件人电话查询集采订单
export function queryEnterpriseOrder(params) {
  return http.post(`${PREFIX}/enterprisePurchase/query`, params);
}
